import { useMutation, UseMutationResult } from '@tanstack/react-query'
import {
  updateReaderActiveTimeReadTasksUpdateActiveTimePatch,
  HTTPValidationError,
  ReaderActiveTimeResult,
  ReaderActiveTimeRequest,
} from '@common/config/api/client'
import { AxiosError } from 'axios'

interface Params {
  readerActiveTimeData: ReaderActiveTimeRequest
}

export const useSaveReaderActiveTime = (): UseMutationResult<
  ReaderActiveTimeResult,
  AxiosError<HTTPValidationError>,
  Params
> => {
  return useMutation<ReaderActiveTimeResult, AxiosError<HTTPValidationError>, Params>({
    mutationFn: async ({ readerActiveTimeData }) => {
      const response = await updateReaderActiveTimeReadTasksUpdateActiveTimePatch({
        body: readerActiveTimeData,
        throwOnError: true,
      })
      return response.data
    },
  })
}
